import React from "react";

const AuthLayout = ({ title, children }) => {
  return (
    <div className="container vh-100 d-flex align-items-center justify-content-center">
      <div className="col-md-5">
        <div className="card shadow-sm border-0">
          <div className="card-body p-4">
            <h4 className="text-center mb-4">{title}</h4>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
